interface Props {
  onDismiss: () => void
}

export function ModeAutoHint({ onDismiss }: Props) {
  return (
    <div className='cf3-mode-auto-hint' role='status' aria-live='polite'>
      <p className='cf3-mode-auto-hint__text'>
        Modo <strong>Obra</strong> ativado pela fase da construção. Troque em <strong>Guia</strong>{' '}
        ou <strong>Obra</strong> no topo da tela.
      </p>
      <button type='button' className='cf3-mode-auto-hint__btn' onClick={onDismiss}>
        Entendi
      </button>
    </div>
  )
}
